<template>
  <div class="user-list">
    <div class="list-header">
      <h2>用户管理</h2>
    </div>
    <el-table :data="users" border>
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="username" label="用户名"></el-table-column>
      <el-table-column prop="email" label="邮箱"></el-table-column>
      <el-table-column prop="phone" label="手机号"></el-table-column>
      <el-table-column prop="isAnonymous" label="是否匿名">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isAnonymous ? 'warning' : 'success'">
            {{ scope.row.isAnonymous ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="注册时间"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="small" type="danger" @click="deleteUser(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 50]"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import { getUsers, deleteUser } from '@/api/blog'

export default {
  name: 'UserList',
  data() {
    return {
      users: [],
      page: 1,
      size: 10,
      total: 0
    }
  },
  mounted() {
    this.loadUsers()
  },
  methods: {
    async loadUsers() {
      const res = await getUsers(this.page - 1, this.size)
      this.users = res.data.content
      this.total = res.data.totalElements
    },
    handleSizeChange(val) {
      this.size = val
      this.loadUsers()
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadUsers()
    },
    async deleteUser(id) {
      if (confirm('确定要删除这个用户吗？')) {
        await deleteUser(id)
        this.loadUsers()
        this.$message.success('删除成功')
      }
    }
  }
}
</script>

<style scoped>
.user-list {
  padding: 20px;
}

.list-header {
  margin-bottom: 20px;
}
</style>
